import { ReactNode } from 'react'
import { Link } from 'react-router-dom'

import cn from 'classnames'

import styles from './CustomLink.module.scss'

interface Props {
  to: string

  variant: 'contained' | 'outlined' | 'not-active' | 'more'
  color?: 'violet' | 'white' | 'orange' | string
  opacity?: boolean

  children: ReactNode
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void
  className?: string
}

export const CustomLink: React.FC<Props> = ({ to, variant, color, opacity, children, className, onClick }) => {
  const linkClass = cn(styles.link, className, {
    [styles[`${variant}`]]: variant,
    [styles[`${color}`]]: color,
    [styles.opacity]: opacity === true,
  })

  return (
    <Link to={to} className={linkClass} onClick={onClick}>
      {children}
    </Link>
  )
}
